import React from "react";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import ListItemTab from "./ListItemTab";

const QuestionDatabaseItems = ({ onClick, active }) => {
  return (
    <ListItemTab
      icon={DocumentTextIcon}
      label="Question Database"
      onClick={onClick}
      active={active}
    />
  );
};

export default QuestionDatabaseItems;
